module.exports = {
      id: "protichinta-logo-usage",
      viewBox: "0 0 190 57.9",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#protichinta-logo",
      toString: function () {
        return this.url;
      }
    }